module.exports = __webpack_public_path__ + "img/0Q3B5909-12_H_Foamcore.1f5a2ca6.jpg";